<template lang="pug">
  #ChallengeJoinButton(v-if="! challenge.isPvsPChallenge")
    JoinChallengeWithTeam(
      v-if="challenge.between === 'groups' && ! challenge.isPvsPChallenge"
      :challenge="challenge"
      mode="static"
    )
    WtJoinButton(
      v-else-if="! challenge.isPvsPChallenge"
      :challenge="challenge"
      :is-text="isText"
    )
</template>

<script>
import WtJoinButton from "@@/WtJoinButton/WtJoinButton";
import JoinChallengeWithTeam from "@@/Challenge/JoinChallengeWithTeam";

export default {
  name: "ChallengeJoinButton",

  components: {
    JoinChallengeWithTeam,
    WtJoinButton
  },

  props: {
    challenge: {
      type: Object,
      default: () => {}
    },
    isText: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="sass" scoped></style>
